import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';
import { ReportsBrowser } from '@/features/reports/ReportsBrowser';
import { useTenant } from '@/lib/tenant';

function ReportsBrowserRoute() {
  const { slug } = Route.useParams();
  const { setSlug } = useTenant();
  useEffect(() => {
    setSlug(slug);
  }, [slug, setSlug]);
  return <ReportsBrowser slug={slug} />;
}

export const Route = createFileRoute('/tenants/$slug/reports/')({
  component: ReportsBrowserRoute,
});
